export enum ContractCreationFileType {
    // specifici per il processo di ricontrattualizzazione
    Csv1Ee,
    Csv1Gg,

    // creazione contratti generica
    Csv2Ee,
    Csv2Gg
}



// WEBPACK FOOTER //
// ./src/app/pages/common/contract-from-file/contract-creation-file.type.ts